!function () {
    if (window.golfbox === undefined) {
        window.golfbox = window.gb = {};
    }

    let _ = {};
    window.gb.feedback = _;

    _.create = function (options) {
        let modal = `
            <div class="notification expanded ${options.type}" onclick="gb.ui.collapse(this);">
                <div class="notification-icon">
                    <span class="${options.icon} icon32White"></span>
                </div>
                <div class="notification-content">
                    <div class="notification-title">${options.title}</div>
                    <div class="notification-message">${options.message}</div>
                    <div class="notification-close">
                        <span class="icon-mini_remove"></span>
                    </div>
                </div>
            </div>
        `;

        if (options.type.toLowerCase() === 'success') {
            modal += `
                <script type="text/javascript">
                    setTimeout(function () {
                        $('.notification.success:not(.collapsed)').each(function (i, elm) {
                            gb.ui.collapse(elm);
                        });
                    }, 3000);
                </script>
            `;
        }

        return modal;
    };
}();